// import {PWMAT_RESOURCE} from './consts'

export const Camp = [{
  name:'1. Electrocatalysis topics',
  url:'https://www.bilibili.com/video/BV1Tx4y1j7YY/?spm_id_from=333.999.0.0&vd_source=0bdf27b8ade1d978776892ded53af857',
  file_name:'d-band center, HER step diagram, solvent effect, constant potential method, OER step diagram, catalytic volcano diagram, Bourbaix diagram'
},
{
  name:'2. Lithium battery topics',
  url:'https://www.bilibili.com/video/BV1WM4y1X7wr/?spm_id_from=333.999.0.0&vd_source=0bdf27b8ade1d978776892ded53af857',
  file_name:'lithium ion injection, voltage evolution, phase diagram calculation, NEB, Dimer method calculation of lithium transport'
},
{
  name:'3. Semiconductor defect topics',
  url:'https://www.bilibili.com/video/BV1Ny4y1Q7rh/?spm_id_from=333.999.0.0&vd_source=0bdf27b8ade1d978776892ded53af857',
  file_name:`formation energy, configuration coordinates and optical transition energy levels,
  point defect diffusion, point defect luminescence mechanism and characteristics, point defect non-radiative recombination`
},
{
  name:'4.TDDFT time-dependent density functional theory topics',
  url:'https://study.163.com/course/introduction/1213097807.htm',
  file_name:'basic principles, real-time rt-TDDFT, linear response lr-TDDFT, excited states and non-adiabatic molecular dynamics'
},
]
export const qs = [{
  name:'1.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1oi4y1W7Yh/?spm_id_from=333.337.search-card.all.click&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'How to enter Q-Studio and interface introduction'
},
{
  name:'2.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1ik4y1U7Wu/?spm_id_from=333.337.search-card.all.click&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'file import and export'
},
{
  name:'3.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1ie411Y7HY/?spm_id_from=333.337.search-card.all.click&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'primitive cell to idiomatic cell conversion'
},
{
  name:'4.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1He411E7rx/?spm_id_from=333.337.search-card.all.click&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'Creating supercells'
},
{
  name:'5.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1im41197Au/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'constructing vacancy defects'
},
{
  name:'6.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1Bu4m1N78d/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'Constructing substitutional doping defects'
},
{
  name:'7.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1Sp421d7Ua/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'Creating a new crystal structure'
},
{
  name:'8.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV12y421e75N/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'small molecule modeling - H2O'
},
{
  name:'9.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1WK42117Ms/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'small molecule modeling - C3H4O3'
},
{
  name:'10.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1Hx42197DX/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'surface construction'
},
{
  name:'11.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1BK421y7Cv/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'fixed atoms'
},
{
  name:'12.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1R7421P76y/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'adding single atoms'
},
{
  name:'13.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1uJ4m1478x/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'adding molecules'
},
{
  name:'14.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1LA4m1L73M/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'adding interstitial atoms'
},
{
  name:'15.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1d2421w7Kv/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'Building two-dimensional materials (single-layer graphene)'
},
{
  name:'16.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1RC411B7rs/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'lattice transformation'
},
{
  name:'17.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1Tv421i75D/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'Building heterojunctions (similar lattice constants)'
},
{
  name:'18.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV1Em41197Qt/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'Building heterojunctions (large lattice constant difference)'
},
{
  name:'19.Q-Studio Modeling Tips',
  url:'https://www.bilibili.com/video/BV12U421Z7xF/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'Building heterojunctions (2D materials)'
},
]
